import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDataExplode = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="M16 5.47a.25.25 0 0 0-.2-.246l-.05-.005H4.232a.25.25 0 0 0-.25.25V9.17c0 .138.112.25.25.25H15.75a.25.25 0 0 0 .25-.25zm1.5 3.7a1.75 1.75 0 0 1-1.75 1.75H4.232a1.75 1.75 0 0 1-1.75-1.75v-3.7c0-.967.784-1.75 1.75-1.75H15.75l.178.008A1.75 1.75 0 0 1 17.5 5.469zM15.598 12.115l.077.004a.75.75 0 0 1 0 1.492l-.077.004H4.383a.75.75 0 0 1 0-1.5zM14.59 14.782l.077.004a.75.75 0 0 1 0 1.492l-.076.004H5.409a.75.75 0 0 1 0-1.5z" />
  </svg>
);
export default SvgDataExplode;
